export default "__VITE_ASSET__BBTbaI$i__"